enum NavPayloadAction {
  ViewFavorites = 'view-favorites',
  ViewFinancing = 'view-terms',
  ViewMyCars = 'view-my-cars',
  ViewOpd = 'view-opd',
  ViewSavedSearches = 'view-saved-searched',
  ViewSrp = 'view-srp',
  ViewTrades = 'view-trade-offer',
  ViewVdp = 'view-vdp'
}

export default NavPayloadAction;
